import {Component, ElementRef, Inject, OnInit, PLATFORM_ID, ViewChild} from '@angular/core';
import {DeviceDetectorService} from 'ngx-device-detector';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
import { FormsUtils } from 'src/app/utils/FormUtils';

declare var hbspt: any;

@Component({
    selector: 'app-soporte',
    templateUrl: './soporte.component.html',
    styleUrls: ['./soporte.component.scss']
})
export class SoporteComponent implements OnInit {
    tam: number;
    num: number;
    @ViewChild('main')
    main: ElementRef;
    /* VARIABLES PARA SABER SI SON MOVILES */
    isMobile: any = false;
    isTablet: any = false;
    idForm: string;

    constructor(
        private deviceService: DeviceDetectorService,
        @Inject(PLATFORM_ID) private platformId: any,
        @Inject(DOCUMENT) private document: any,
        private _formsUtils: FormsUtils
    ) {
        this.isMobile = this.deviceService.isMobile();
        this.isTablet = this.deviceService.isTablet();
        window.scrollTo(0, 0);
        this.num = 0;
    }

    ngOnInit(): void {
        if (isPlatformBrowser(this.platformId)) {

            const ancla = sessionStorage.getItem('ancla');
            sessionStorage.removeItem('ancla');
            console.log(ancla)
            const scrollTo = ancla ? ancla : 'inicio';
        
            // Verificar si el elemento con el ID existe en el DOM
            const targetElement = this.document.getElementById(scrollTo);
              console.log(targetElement)
            if (targetElement) {
              setTimeout(() => {
                targetElement.scrollIntoView({
                  behavior: "instant",
                  block: "start",
                  inline: "nearest"
                });
              }, 300);
            }
          }
        // if (this.isMobile === true || this.isTablet === true) {
        //     hbspt.forms.create({
        //         portalId: '5707307',
        //         formId: '5f2fd99c-96f0-4e69-ae4b-fadb6c07d9d3',
        //         target: '#form-support-movil'
        //     });
        // } else if (this.isMobile === false && this.isTablet === false) {
        //     hbspt.forms.create({
        //         portalId: '5707307',
        //         formId: '5f2fd99c-96f0-4e69-ae4b-fadb6c07d9d3',
        //         target: '#form-support'
        //     });
        // }
        this.idForm = this._formsUtils.getFormIdByLang();
        this._formsUtils.buildSovosForm();
    }

}
